









































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { IGame } from '~/store/games/types';
import { Hooper, Navigation as HooperNavigation, Slide } from 'hooper';

@Component({
  components: {
    Hooper,
    Slide,
    HooperNavigation,
  },
})
export default class GameCarousel extends Vue {
  @Prop(Array) readonly games!: IGame[];
  @Prop(String) readonly title!: string;

  hooperSettings = {
    infiniteScroll: false,
    itemsToSlide: 1,
    trimWhiteSpace: true,
    wheelControl: false,
    touchDrag: true,
  };

  get visibleCarouselGames() {
    const screenWidth = this.$vuetify.breakpoint.width;

    return screenWidth < 960 ? 1 : screenWidth <= 1300 ? 2 : 3;
  }

  viewAll() {
    this.goto('/games');
  }

  goto(route: string) {
    this.$router.push(route);
  }
}
